var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',[_c('div',{staticClass:"vx-row"},[_c('Garantie'),_c('templateSMS'),_c('Caisse'),_c('Ferier'),_c('ConfigSMS')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }